export const API_URLs = {
    GENERATE_OTP : '/auth/validate',
    LOGIN: '/auth/influencer/login',
    REGISTER: '/auth/influencer/register',
    GET_USER_PROFILE: '/user/profile',
    INFLUENCER_PROFILE: '/i/me',
    FETCH_CAMPAIGNS: '/campaign',
    FETCH_CAMPAIGN: '/campaign/<campaignId>',
    FETCH_PUBLIC_CAMPAIGN: '/c/<campaignId>',
    STORE_ACCESS_TOKEN: '/i/c/ig/init',
    LIST_IG_ACCOUNTS: 'i/c/ig/l?via=ig',
    LINK_IG_ACCOUNT: '/i/c/ig/l/<accountId>',
    APPLICATION: '/i/application/<campaignId>',
    INSIGHTS: 'i/insights',
    INFLUENCER_MEDIA: 'i/post',
    INFLUENCER_POST: 'i/post/<postId>',
    COLLABORATIONS: 'i/collaboration',
    COLLABORATION: 'i/collaboration/<campaignId>',
    COLLABORATION_MEDIA: 'i/collaboration/<campaignId>/post',
    COLLABORATION_SHORT_URL: 'i/collaboration/<campaignId>/short-url',
    FETCH_MEDIA: '/i/social-account/<socialAccountId>/fetch-media',
    REFERRALS: 'i/referral',
    FETCH_CITIES: '/i/city/list',
    MEMBERSHIP: 'i/membership',
    CHANGE_MEMBERSHIP: 'i/membership/<activePlanUUID>',
    VERIFY_MEMBERSHIP_PAYMENT: 'pay/rzp/checkout/cb/<paymentUUID>',
    PRICING: 'i/pricing',
    PRICING_PUBLIC: 'pricing',
    WALLET: '/i/wallet',
    VALIDATE_IFSC: 'i/payout-account/validate-ifsc',
    SAVE_BANK_DETAILS: 'i/payout-account',
    PAYOUT: 'i/payout',
    FETCH_NEAREST_CITY: 'i/city/nearest'
}